import * as React from "react";
import styled from "styled-components";
import Copy from "../Copy";
import { colorAttentionBlue10, colorAttentionBlue50, colorAttentionGreen10, colorAttentionGreen50, colorAttentionRed10, colorAttentionRed50, colorAttentionYellow10, colorAttentionYellow50, colorBrandRhumbixBlack, colorMiscGray90, spacingM, spacingL, IconActionsRequired, IconCheckThick, IconCSVDocument, IconWarningFilled, IconX, } from "@rhumbix/rmbx_design_system_design_tokens";
const Notification = ({ message, onClick, type, className, children }) => (React.createElement(Container, { className: className, onClick: onClick, type: type, id: `notification-${type}` },
    React.createElement("div", { className: "context-icon" }, type === "error" ? (React.createElement(IconWarningFilled, null)) : type === "success" ? (React.createElement(IconCheckThick, null)) : type === "warning" ? (React.createElement(IconActionsRequired, null)) : (React.createElement(IconCSVDocument, null))),
    React.createElement(Copy, { color: colorMiscGray90, bold: true }, message),
    children,
    React.createElement("div", { className: "x-icon" },
        React.createElement(IconX, { color: getPrimaryColor(type) }))));
const getPrimaryColor = (type) => type === "error"
    ? colorAttentionRed50
    : type === "success"
        ? colorAttentionGreen50
        : type === "warning"
            ? colorAttentionYellow50
            : colorAttentionBlue50;
const Container = styled.div `
    // Override these defaults with styled(Notification)
    width: 90%;
    max-width: 720px;
    position: absolute;

    display: flex;
    align-items: center;
    padding: ${spacingM};
    // Ensure the content does not overlap with the "X"
    padding-right: ${spacingL};
    border-radius: 4px;
    box-shadow: 2px 2px 4px 0 ${colorBrandRhumbixBlack}40;

    border: 1px solid ${({ type }) => getPrimaryColor(type)};
    background-color: ${({ type }) => type === "error"
    ? colorAttentionRed10
    : type === "success"
        ? colorAttentionGreen10
        : type === "warning"
            ? colorAttentionYellow10
            : colorAttentionBlue10};

    .context-icon {
        width: 24px;
        line-height: 0;
        margin-right: ${spacingM};
        color: ${({ type }) => getPrimaryColor(type)};
    }

    .x-icon {
        position: absolute;
        top: ${spacingM};
        right: ${spacingM};
        width: 10px;
        line-height: 0;
        color: ${({ type }) => getPrimaryColor(type)};
    }

    &:hover {
        cursor: pointer;
    }
`;
export default Notification;
